module.exports = __webpack_public_path__ + "4f1e1808028fa49ef475515ee74d7824.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/en.json
// module id = 1124
// module chunks = 0